import React, { Component } from 'react';
import { CustomContent } from '../../../../components';
import { connect } from 'react-redux';
import { translate, getLanguages } from '../../../../services';
import { productState, configuratorState, combineStates, currentNodeState, productsDispatcher } from '../../../../store';
import { PropTypes } from 'prop-types';
import { TranslationService, getTranslationModelName, deflateModelVariables, getAssignedValue, updateProductDescription } from '../../../../util';
import { ModelConfigurator } from '../model';import classNames from 'classnames';
;

export class BomItemComponent extends Component {
  constructor( props ) {
    super( props );
    this.loadingStatus = {};
  }

  componentDidMount() {
    this.loadProductsFromProps( this.props );
  }

  componentDidUpdate() {
    this.loadProductsFromProps( this.props );
  }

  loadProductsFromProps( props ) {
    const { item, products} = props;
    const productCode = this.getAssignedValue( item );

    if(props.fromModelConfiguratorSelector){
      return
    }
    if ( products[productCode] === undefined && !this.loadingStatus[productCode] ) {
      this.loadingStatus[productCode] = true;
      this.props.getProduct( productCode ).then( () => this.loadingStatus[productCode] = false );
    }
  }

  getConfiguration(props)
  {
    const{configurations, currentNode} = props;
    const configuration = currentNode.customProperties && currentNode.customProperties.serviceConfigurator == true ? configurations[currentNode.configuratorName] && configurations[currentNode.configuratorName][0] : null;

    if ( !configuration ) {
      return null;
    }

    const translationService = TranslationService( getTranslationModelName( configuration ), 'model' )( getLanguages().first() );
    return { ...configuration, model: translationService.withGroups( configuration.model ) };
  }

  /* updateProductDescription ( description ){
    const { configurations, currentNode }= this.props;
    const configuration = currentNode.customProperties && currentNode.customProperties.serviceConfigurator == true ? configurations[currentNode.configuratorName] && configurations[currentNode.configuratorName][0] : null;
    const { model } = configuration;
    const variables = deflateModelVariables( model );
    const { concatenators } = currentNode && currentNode.customProperties;
    return concatenators && concatenators.reduce( ( description, current ) => { 
      const variable = variables.firstOrDefault( v => v.fullyQualifiedName === current );
      const assignedValue = variable && variable.show && getAssignedValue( variable );
      //const assignedValue = variable && variable.properties && variable.properties.CalculatedValue ? variable.properties.CalculatedValue : `${variable.title};`+getAssignedValue( variable );
      if ( assignedValue){
        description = `${description.toString().trim()} ${variable && variable.properties && variable.properties.CalculatedValue ? variable.properties.CalculatedValue : ""}`;
      }
      return description;
    }, description );
  } */

  getAssignedValue( variable ) {
    return variable && variable.showAs === 'Calculated'
      ? variable.properties.CalculatedValue
      : variable.assignedValue
        ? variable.assignedValue.name
        : variable.properties.DefaultValue;
  }

  renderCell( column, item, columnIndex, itemIndex ) {
    if(column.props?.className==="mobile-product-detail"){
      return <div className='mobile-product-detail'>
        {column.props?.children?.map((child)=>{
          return <div className={child.title}><CustomContent layout={ child } data={ item } /></div>
        })}
      </div>
    }
    return <div key={ itemIndex * columnIndex + columnIndex } className={ classNames('width-' + column.width, {'quantity-column': column.title==="Quantity"}) }>
      <CustomContent layout={ column } data={ item } />
    </div>;
  }

  getBALID(configuration, currentNode){
    const { model } = configuration;
    const variables = this.getAllVariables( model );
    const {BALID} = currentNode.customProperties;
    const variable = variables.firstOrDefault( v => v.fullyQualifiedName === BALID );
    return getAssignedValue(variable);
  }

  getCID(configuration, currentNode){
    const { model } = configuration;
    const variables = this.getAllVariables( model );
    const {NodeCID} = currentNode.customProperties;
    const variable = variables.firstOrDefault( v => v.fullyQualifiedName === NodeCID );
    return getAssignedValue(variable);
  }

  getAllVariables( model ) {
    return deflateModelVariables( model );
  }

  render() {
    const { columns, item, itemIndex, products, currentNode } = this.props;
    const productCode = this.getAssignedValue( item );
    const product = this.props.fromModelConfiguratorSelector && item? item : products[productCode];

    if ( product === undefined ) { // not yet loaded
      return null;
    }

    if ( product === null ) { // it is not available
      return <div className="row col-12 product product-not-available">
        <span className="col-1 title bold"></span>
        <span className="col-3 title bold id">{ productCode }</span>
        <span className="col-7 title bold description">{ translate( 'Product is not available.' ) }</span>
        <span className="col-2 title bold"></span>
        <span className="col-2 title bold"></span>
        {/* <span className="col-10 description"></span> */}
      </div>;
    }

    if ( product.obsolete ) { // it is defined but not available
      return <div className="row col-12 product product-not-available">
        <span className="col-1 title bold"></span>
        <span className="col-3 title bold id">{ productCode }</span>
        <span className="col-7 title bold description">{ translate( 'Product is not available.' ) }</span>
        <span className="col-2 title bold"></span>
        <span className="col-2 title bold"></span>
      </div>;
    }

    const configuration = this.getConfiguration(this.props);
    product.description = product.productDescription && updateProductDescription(product.productDescription, configuration, currentNode);
    if((product.bALID == "" || product.bALID === undefined) && configuration){
      product.bALID = this.getBALID(configuration, currentNode);
    }

    if((product.nodeCID == "" || product.nodeCID === undefined) && configuration){
      product.nodeCID = this.getCID(configuration, currentNode);
    }
    const modifiedProduct = { ...product, _bom: item };

    return columns.map( ( column, key ) => this.renderCell( column, modifiedProduct, key, itemIndex ) );
  }
}

BomItemComponent.propTypes = {
  columns: PropTypes.arrayOf( PropTypes.object ),
  getProduct: PropTypes.func.isRequired,
  item: PropTypes.shape( {

  } ),
  itemIndex: PropTypes.number,
  products: PropTypes.shape( {} )
};

export const BomItem = connect( combineStates(productState,configuratorState,currentNodeState), productsDispatcher )( BomItemComponent );